/** Hero / marketing column on the start (inline-start) side. */
export const SplitLayoutSide = {
    LEFT: 'left',
    RIGHT: 'right',
};

/**
 * `default` — ~40% form / ~60% hero (Clockout for Banks desktop).
 * `equal` — 50% / 50%.
 * `twoThirds` — ~67% main / ~33% sidebar (admin pages inside `Layout`, Figma 5851:570).
 */
export const SplitLayoutVariant = {
    DEFAULT: 'default',
    EQUAL: 'equal',
    TWO_THIRDS: 'twoThirds',
};
